import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import FormFlex from 'components/shared/form/Flex';
import FormBox from 'components/shared/form/Box';
import { Icon } from 'components/shared';
import avatar from './avatar.png';

const propTypes = {
  loanOfficer: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
};

function LoanOfficer(props) {
  const { loanOfficer } = props;

  const { firstName, lastName, email, phone } = loanOfficer;

  return (
    <ContactInfoFormFlex alignItems="center" justifyContent="center">
      <FormBox>
        <StyledImage><Icon icon='userTie' width='1.875' /></StyledImage>
      </FormBox>
      <FormBox>
        <Name>{`${firstName} ${lastName}`}</Name>
        <Phone>{phone}</Phone>
        <Mail href={`mailto::${email}`}>{email}</Mail>
      </FormBox>
    </ContactInfoFormFlex>
  );
}

const ContactInfoFormFlex = styled(FormFlex)`
  padding: 1.1875rem 0;
`;

const Img = styled.img`
  display: block;
  width: 3.125rem;
  height: 3.125rem;
  min-width: 3.125rem;
  border-radius: 100%;
`;
const StyledImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:var(--color-icon-background);
  border-radius: 100%;
  width: 4em;
  height: 4em;
  color: var(--color-primary);
`

const textStyle = css`
  color: var(--color-secondary-text);
  display: block;
  text-align: left;
  font-size: var(--font-size-base);
`;

const Name = styled.span`
  ${textStyle};
`;

const Phone = styled.span`
  ${textStyle};
`;

const Mail = styled.a`
  ${textStyle};
  text-decoration: none;
`;

LoanOfficer.propTypes = propTypes;

export default LoanOfficer;
